import { Component, output } from '@angular/core';
import { ICard } from '../../shared/models/card.model';
import { CardComponent } from '../../shared/components/card/card.component';
import { TodoService } from './services/todo.service';
import { IEvent, IEventResponse } from './models/event';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-todo',
  templateUrl: './todo.component.html',
  styleUrls: ['./todo.component.scss'],
  standalone: true,
  imports: [CardComponent, MatIconModule],
  providers: [TodoService],
})
export class TodoComponent {
  cards: ICard[] = [];
  errorMessages: string | undefined;
  loadingEvent = output<boolean>();


  constructor(private todoService: TodoService) {}

  ngOnInit() {
    this.loadingEvent.emit(true);
    this.todoService.getCards().subscribe(({ todos }) => {
      const cards = todos.map((todo) => {
        let card: ICard = {
          title: todo.title,
          description: todo.description,
          status: TodoComponent.transformDate(todo.dueDate) > new Date() ? 'On time' : 'Overdue',
          dueDate: TodoComponent.transformDate(todo.dueDate),
          id: todo.id,
          delete: () => this.deleteCard(card),
          save: () => this.updateCard(card),
        };
        return card;
      });
      this.cards = cards.reverse();
      this.loadingEvent.emit(false);
    }, (error) => {
      this.errorMessages = error.message;
      this.loadingEvent.emit(false);
    });
  }

  static transformDate(date: string): Date {
    let [day, month, year] = date.split('/')
    const dateObj = new Date(+year, +month - 1, +day)
    return dateObj;
  }

  static transformDateToDDMMYYYY(date: string): string {
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  }

  addCard() {
    const newCard: ICard = {
      id: '',
      title: 'New Event',
      description: 'Event description',
      status: 'On time',
      dueDate: TodoComponent.transformDate(new Date().toLocaleDateString()),
      delete: () => this.deleteCard(newCard),
      save: () => this.saveCard(newCard),
    };
    this.cards.unshift(newCard);
  }

  deleteCard(card: ICard) {
    if (!card.id) {
      this.cards = this.cards.filter((c) => c !== card);
      return;
    } else {
      this.todoService.deleteCard(card.id).subscribe(() => {
        this.cards = this.cards.filter((c) => c !== card);
      });
    }
  }

  saveCard(card: ICard) {
    const eventToUpdate = this.createEvent(card);
    this.todoService.saveCard(eventToUpdate).subscribe(({ id }: IEventResponse) => {
      const index = this.cards.findIndex((c) => c === card);
      this.cards[index].id = id;
      this.cards[index] = card;
    });
  }

  updateCard(card: ICard) {
    const eventToUpdate = this.createEvent(card);
    this.todoService.updateCard(eventToUpdate).subscribe(() => {
      const index = this.cards.findIndex((c) => c === card);
      this.cards[index] = card;
    });
  }

  createEvent(event: ICard): IEvent {
    const eventToUpdate: IEvent = {
      id: event.id,
      title: event.title,
      description: event.description,
      dueDate: TodoComponent.transformDateToDDMMYYYY(event.dueDate.toString())
    }
    return eventToUpdate;
  }
}
